export default __webpack_public_path__ + "static/media/silenceimmunity.94da1876.png";